import { ApiPath } from "enums";
import { Get } from "utils";

export const getDailyRecordsByStation = async (query) => {
  const res = await Get(`${ApiPath.DailyRecords}/station/${query?.stationCode}`, query);
  return res.data;
};
